import { combineReducers } from 'redux';

import { StatesState } from './types';
import * as actions from './actions';
import { BaseActions, createBaseListReducer, createBaseErrorMessageReducer, createBaseRequestInProgressReducer } from '../../core';
import { StateModel } from '../../api/interfaces';

export const initialState: StatesState = {
    itemList: {
        allIds: [],
        byId: {},
        loaded: false
    },
    errorMessage: '',
    requestInProgress: false
};

const baseActions = {
    getItemsAsync: actions.getItemsAsync,
    saveItemAsync: actions.saveItemAsync,
    deleteItemAsync: actions.deleteItemAsync,
    editItemAsync: actions.editItemAsync
} as BaseActions<StateModel>;

const itemListReducer = createBaseListReducer(initialState.itemList, baseActions);

const errorMessageReducer = createBaseErrorMessageReducer(initialState.errorMessage, baseActions);

const requestInProgressReducer = createBaseRequestInProgressReducer(initialState.requestInProgress, baseActions);

export default combineReducers<StatesState>({
    itemList: itemListReducer,
    requestInProgress: requestInProgressReducer,
    errorMessage: errorMessageReducer
});
